const latamCountries = [
    'AR',
    'BO',
    'CL',
    'CO',
    'CR',
    'DO',
    'EC',
    'SV',
    'GT',
    'HT',
    'HN',
    'MX',
    'NI',
    'PA',
    'PY',
    'PE',
    'UY',
    'VE',
];

const menaRegions = [
    'BH',
    'OM',
    'QA',
    'DZ',
    'SA',
    'AE',
    'KW',
    'IQ',
    'JO',
    'LB',
    'PS',
    'LY',
    'EG',
    'MA',
    'TN',
    'YE',
];

export { latamCountries, menaRegions };
